import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a8b43dce"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "question-banner"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-jp.theckb.com/static-asset/client/question_banner/banner.png",
  alt: "",
  class: "bg"
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "btn",
  href: "https://docs.google.com/forms/d/e/1FAIpQLSdbhdoGNSSaiq-KrvDI-2_7o9CtVHVrLrfWkD5Y5GQk6ti9eg/viewform",
  target: "_blank"
}, "アンケート回答はこちら", -1))
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

import { useStore } from 'vuex'
import { isJA } from '@/store'
import { computed } from 'vue'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()
const whiteList = [
  7,
  2415,
  2568,
  4717,
  4847,
  7247,
  7359,
  12644,
  16741,
  21063,
  30312,
  30856,
  31024,
  33211,
  33243,
  33941,
  34165,
  34954,
  35567,
  35659,
  35932,
  36316,
  36504,
  36804,
  35236,
  36782,
  36816,
  37075,
  37077,
  37140,
  37223,
  37230
]
const show = computed(() => {
  return isJA() && (new Date().getTime() < new Date('2025/12/31 23:59:59').getTime()) && whiteList.includes(store.getters.user?.superCustomerId)
})

return (_ctx: any,_cache: any) => {
  return (_unref(show))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
    : _createCommentVNode("", true)
}
}

})